import { ImagingIcon } from '@/components/icons';

export function DatabaseSwitcherSkeleton() {
  return (
    <div className="relative w-full">
      <div className="flex w-full items-center gap-1 h-10">
        <div className="flex items-center w-full gap-2">
          <ImagingIcon className="w-8 fill-redtail-red" />
          <div className="h-5 w-32 rounded-full bg-skeleton-text animate-pulse hidden sm:inline" />
        </div>
      </div>
    </div>
  );
}
